module.exports = __webpack_public_path__ + "static/bathbooks-c2a4794c3bbb9bb66e79eef19cbab1b3.jpeg";